import request from '@/utils/requestFile'

/**
 * 上传图片，识别身份证正面，或则反面
 * @param {*} data
 * @returns
 */
export function identityDetect6(data, headers) {
    return request({
        url: 'cf87e1afc16585b586',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 活体，上传脸部拍照照片
 * @param {*} data
 * @returns
 */
export function verifyLive(data, headers) {
    return request({
        url: '4a818acdced6d7d1a1',
        method: 'post',
        data,
        headers,
    })
}